import * as React from 'react'
import MUITableCell from '@mui/material/TableCell'

const TableCell = (props) => <MUITableCell {...props} />

export default TableCell
